import {
  css,
  DefaultTheme,
  FlattenInterpolation,
  Interpolation,
  ThemedStyledProps
} from 'styled-components';
import themeContract from '../providers/Theme/themeContract.json';

// `:root[data-theme='light'] &` never matches under styled-components scoping; `:is()` does.
export const LIGHT_THEME_SELECTOR = themeContract.lightSelector;

export const onLightTheme = <P extends object = object>(
  strings: TemplateStringsArray,
  ...interpolations: Interpolation<ThemedStyledProps<P, DefaultTheme>>[]
): FlattenInterpolation<ThemedStyledProps<P, DefaultTheme>> => css`
  &${LIGHT_THEME_SELECTOR} {
    ${css(strings, ...interpolations)}
  }
`;

export const MUTED_LIGHT_INK = 'var(--ln-content-muted)';
export const LIGHT_DIM_OPACITY = 0.7;

export const lightDim = onLightTheme`
  opacity: ${LIGHT_DIM_OPACITY};
`;
